<script>
    import TileWrapper from "./TileWrapper.svelte";
    import { two_col_mode } from "../../stores.js";
  
    export let peers;
    export let hide = false;

    $: twoColMode = $two_col_mode;

</script>
<!-- 
is_eng_tile={peer.type === "eng"}
is_talent_tile={peer.type === "talent"} -->
<div class="tiles" class:two-col={twoColMode} class:hidden={hide}>
    {#each peers as peer (peer.id)}
        <TileWrapper {peer} />
    {/each}
</div>

<style lang="scss">
    
    .tiles {
        
        @import "../styles/main.scss";

        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: baseline;
        height: 100%;
        
        grid-gap: $space-sm;
        margin: $space-sm;

        overflow: auto;

        -webkit-overflow-scrolling: touch; 

        &.hidden {
            display: none;
        }

    }
</style>
